module.exports = __webpack_public_path__ + "static/media/zuleika-banner.0941d906.jpg";